import { type FC } from 'react';

import { Icon, type IconTypes } from '@vakantiesnl/components/src/atoms/Icon';
import ImageComponent, { type ImageComponentProps } from '@vakantiesnl/components/src/molecules/ImageComponent';

import { useCustomStyles } from './Avatar.style';

export type AvatarProps = {
	size?: 'xsmall' | 'small' | 'medium' | 'large' | 'jumbo';
	circle?: boolean;
	icon?: IconTypes;
	imageURL?: string;
	dataCy?: string;
};

const imageTrimSize: Record<Required<AvatarProps>['size'], ImageComponentProps['trim']> = {
	xsmall: [24, 24],
	small: [32, 32],
	medium: [40, 40],
	large: [56, 56],
	jumbo: [96, 96],
};

export const Avatar: FC<AvatarProps> = ({ size = 'medium', circle, icon, imageURL, dataCy }) => {
	const { classes: styles } = useCustomStyles({ size, circle });

	return (
		<div className={styles.container}>
			{icon && <Icon className={styles.icon} type={icon} />}
			{imageURL && (
				<div className={styles.imageContainer}>
					<ImageComponent
						trim={imageTrimSize[size]}
						src={imageURL}
						height={imageTrimSize[size]?.[0]}
						width={imageTrimSize[size]?.[1]}
						alt=""
						data-cy={`${dataCy}-image`}
					/>
				</div>
			)}
		</div>
	);
};
